export default __webpack_public_path__ + "static/print2-953877d233900a12c905b117be6bc251.webp";